exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container[data-v-7eb2bc79]{padding:18px 22px 22px 22px;margin-bottom:20px}.dashboard-editor-container .chart-wrapper[data-v-7eb2bc79]{background:#fff;padding:16px 16px 0;margin-bottom:32px}.block[data-v-7eb2bc79]{text-align:right;margin-top:25px}.btn[data-v-7eb2bc79]{margin-bottom:10px}", ""]);

// exports
